import { type ComponentProps } from 'react';

import defu from 'defu';
import _ from 'lodash';

import type {
	EditorType,
	EditorVariations,
	QuoteVariations,
	TableVariations,
} from '@/src/Types/Blocks/Editor';
import type { ContainerTypeEnums, PositionsAlignement } from '@/src/Types/Shared/Common';
import type { ContextKey, Options } from '@/src/Types/Shared/Options';
import { EditorStyle, getBtnStyle } from '@Views/Shared/GlobalStyles/GlobalStyles';

import Block from './Block';

type EditorRegister = {
	block: EditorType;
	variant: EditorVariations;
	containerType: ContainerTypeEnums;
	headingAlign: PositionsAlignement;
	wrapperType: ContainerTypeEnums;
	quoteStyle?: QuoteVariations;
	tableStyle?: TableVariations;
	context?: ContextKey;
	options: Options;
};

export default function Editor(props: EditorRegister) {
	const {
		block,
		variant,
		containerType = 'wide',
		headingAlign = 'center',
		wrapperType = 'block',
		quoteStyle = 'classic',
		tableStyle = 'classic',
		options,
	} = props;

	const { composition } = block;

	let propsBlock: ComponentProps<typeof Block> = {
		id: block.id,
		title: block.title,
		description: block.description,
		titleFormat: block.titleFormat,
		content: block.content,
		variant: variant,
		containerType: containerType,
		headingAlign: headingAlign,
		wrapperType: wrapperType,
		quoteStyle: quoteStyle,
		tableStyle: tableStyle,
		contentFontFormats: block.contentFontFormats,
		ctasStyle: getBtnStyle(options, options.blocks.editor.default.ctasStyle),
		style: {},
		placement: block.placement,
		sectionDecoration: options.layout.sectionDecoration,
	};

	if (composition && composition != 'none') {
		const compoOptions = _.find(options.blocks.editor.compositions, { id: composition });
		if (compoOptions) {
			propsBlock = defu(compoOptions as ComponentProps<typeof Block>, propsBlock);
			propsBlock.ctasStyle = getBtnStyle(options, compoOptions.ctasStyle);
			propsBlock.style = EditorStyle(options, compoOptions);
		}
	}

	return <Block {...propsBlock} />;
}
